import DownloadFilesButton from 'features/media/components/molecules/DownloadFilesButton/DownloadFilesButton';

export default DownloadFilesButton;
